import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

// ==============================|| AUTHENTICATION - CARD WRAPPER ||============================== //

export default function AuthCard({ children, ...other }) {
  return (
    <Box
      {...other}
      sx={{
        width: '100%',
        maxWidth: { xs: '100%', sm: 400 },
        mx: 'auto',
        borderRadius: 3,
        bgcolor: '#fff',
        boxShadow: '0 12px 40px rgba(15, 45, 32, 0.1), 0 4px 12px rgba(15, 45, 32, 0.05)',
        border: '1px solid rgba(31, 91, 64, 0.08)',
        overflow: 'hidden',
        animation: 'scaleIn 0.4s ease-out both',
        ...(other.sx || {})
      }}
    >
      <Box
        sx={{
          px: { xs: 2.5, sm: 3 },
          py: { xs: 3, sm: 3.5 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

AuthCard.propTypes = { children: PropTypes.node, other: PropTypes.any };
